import React from 'react'
import AboutBanner from '../Component/about/AboutBanner'
import MissionVision from '../Component/about/MissionVision'
import WhatDifferent from '../Component/about/WhatDifferent'
import TrustSafety from '../Component/about/TrustSafety'
import AboutCTA from '../Component/about/AboutCTA'
import SEO from '../Component/SEO'
export default function About() {
  return (
    <>
    <SEO
      title="About TROGO | Reliable Transport & Logistics Services"
      description="Learn about TROGO’s mission to provide safe, verified and reliable transport services across India."
      keywords="about trogo, transport company india, logistics startup"
      url="https://www.togoodsdraft.com/about"
  />

    <AboutBanner/>
    <MissionVision/>
    <WhatDifferent/>
    <TrustSafety/>
    <AboutCTA/>

    </>
  )
}
